(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class FooterMenu extends DetailsDisclosure {
      constructor() {
        super();
        this.reset(false);
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        const isConfirmNewsletter = !isLargeScreen &&
          (window.location.hash === "#footer-signup_form" && this.querySelector('#footer-signup_form') !== null);

        this.disclosure.open = isLargeScreen || isConfirmNewsletter;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }
    }

    customElements.define('footer-menu', FooterMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class NavMenu extends DetailsDisclosure {
      constructor() {
        super();

        if(this.matches('.js-mega-nav')) {
          this.reset(false);
          window.addEventListener('on:breakpoint-change', this.reset.bind(this));
        }
      }

      reset(resize = true) {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;
        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
        } else {
          this.toggle.removeAttribute('tabindex');
        }
      }

      handleToggle(e) {
        if (!(this.matches('.js-mega-nav') && window.matchMedia(theme.mediaQueries.md).matches)) {
          super.handleToggle(e);
        }
      }
    }

    customElements.define('nav-menu', NavMenu);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wrs-rewards-overview"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('wrs-hero-calculator-v1')) {
  customElements.define('wrs-hero-calculator-v1', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.mount());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearTimeout(this.announcementTimer);
      if (this.controller) this.controller.abort();
    }
    mount() {
      if (!this.isConnected) return;
      this.input = this.querySelector('[data-wrs-spend]');
      this.rows = Array.from(this.querySelectorAll('[data-wrs-tier]'));
      this.error = this.querySelector('[data-wrs-error]');
      this.live = this.querySelector('[data-wrs-live]');
      this.comparison = this.querySelector('[data-wrs-comparison-amount]');
      if (!this.input || this.rows.length !== 3 || !this.error || !this.live || !this.comparison) return;
      if (this.controller) this.controller.abort();
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.money = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' });
      this.numbers = new Intl.NumberFormat('en-US', { maximumFractionDigits: 0 });
      this.buttons = Array.from(this.querySelectorAll('[data-wrs-amount]'));
      this.input.disabled = false;
      this.input.addEventListener('input', () => this.update(true), options);
      this.input.addEventListener('keydown', (event) => {
        if (event.key === 'Enter') { event.preventDefault(); this.update(true); }
      }, options);
      this.buttons.forEach((button) => {
        button.disabled = false;
        button.addEventListener('click', () => {
          this.input.value = button.dataset.wrsAmount;
          this.update(true);
        }, options);
      });
      this.update(false);
    }
    update(announce) {
      clearTimeout(this.announcementTimer);
      const raw = this.input.value.trim();
      const amount = Number(raw);
      const valid = /^(?:\d+(?:\.\d{0,2})?|\.\d{1,2})$/.test(raw) && this.input.validity.valid && Number.isFinite(amount) && amount >= 0 && amount <= 100000;
      this.input.setAttribute('aria-invalid', valid ? 'false' : 'true');
      this.error.hidden = valid;
      this.comparison.textContent = valid ? this.money.format(amount) : '\u2014';
      this.buttons.forEach((button) => button.setAttribute('aria-pressed', String(valid && amount === Number(button.dataset.wrsAmount))));
      const statements = [];
      this.rows.forEach((row) => {
        const rate = Number(row.dataset.rate);
        const rateValid = Number.isFinite(rate) && rate >= 0 && rate <= 1000;
        const usable = valid && rateValid;
        const cents = Math.round(amount * 100);
        const rateUnits = Math.round(rate * 10000);
        const points = usable ? Math.floor((cents * rateUnits) / 1000000) : 0;
        row.querySelector('[data-wrs-points]').textContent = usable ? this.numbers.format(points) : '\u2014';
        row.querySelector('[data-wrs-value]').textContent = usable ? this.money.format(points / 100) : '\u2014';
        if (usable) statements.push(`${row.dataset.tierName}: ${this.numbers.format(points)} ${this.dataset.pointsLabel}, ${this.money.format(points / 100)} ${this.dataset.valueLabel}.`);
      });
      if (announce) {
        this.announcementTimer = setTimeout(() => {
          this.live.textContent = valid ? `${this.money.format(amount)}. ${statements.join(' ')}` : this.dataset.errorMessage;
        }, 250);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
